import { Entity } from '../entity';
import { SystemWorkOrderStatus } from '../job/system.workorder.status';

export enum DependencyType {
    StartToStart = 0,
    StartToEnd = 1,
    EndToStart = 2,
    EndToEnd = 3,
}

export enum GanttConstraintType {
    FinishNoEarlierThan = 'finishnoearlierthan',
    FinishNoLaterThan = 'finishnolaterthan',
    MustFinishOn = 'mustfinishon',
    MustStartOn = 'muststarton',
    StartNoEarlierThan = 'startnoearlierthan',
    StartNoLaterThan = 'startnolaterthan',
    AsSoonAsPossible = 'assoonaspossible',
    AsLateAsPossible = 'aslateaspossible',
}

export enum GanttProjectConstraintResolution {
    Honor = 'honor',
    Ignore = 'ignore',
    Conflict = 'conflict'
}

export enum GanttSchedulingMode {
    Normal = 'Normal',
    FixedDuration = 'FixedDuration',
    FixedEffort = 'FixedEffort',
    FixedUnits = 'FixedUnits',
}

export enum GanttTaskType {
    Task = 'Task',
    Phase = 'Phase'
}

export enum GanttDurationUnit {
    // Milliseconds = 'millisecond',
    // Seconds = 'second',
    // Minutes = 'minute',
    Hours = 'hour',
    Days = 'day',
    Weeks = 'week',
    Months = 'month',
    Quarters = 'quarter',
    Years = 'year'
}

export interface GanttEntity extends Entity {
    $PhantomId?: string;
    // Need this, because get bryntum issue. in the gantt view and go to other view (manage job), then get back to gantt, delete a phase.
    // We get crash in Bryntum. the id mapping form client doesn't work. so don't make the mapping in gantt.model
    id: string;
}

export const ProjectClosedStatus = [SystemWorkOrderStatus.Closed, SystemWorkOrderStatus.Finalised];
